import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export interface LockMonthInput {
  period: string;          // 'YYYY-MM'
  clientId?: string;
}

export interface LockMonthPreviewResponse {
  period: string;
  clientId: string | null;
  tripsToLock: number;
  deductionsToApply: number;
}

export interface LockMonthResponse {
  period: string;
  clientId: string | null;
  lockedAt: string;
  tripsLocked: number;
  deductionsApplied: number;
}

export async function previewLockMonth(input: LockMonthInput): Promise<LockMonthPreviewResponse> {
  const { data } = await apiClient.get<LockMonthPreviewResponse>(
    '/api/v1/closings/preview-lock-month',
    { params: input },
  );
  return data;
}

export async function lockMonth(input: LockMonthInput): Promise<LockMonthResponse> {
  const { data } = await apiClient.post<LockMonthResponse>(
    '/api/v1/closings/lock-month',
    input,
  );
  return data;
}

export function useLockMonthPreview(input: LockMonthInput | null) {
  return useQuery({
    queryKey: ['lock-month-preview', input],
    queryFn: () => previewLockMonth(input!),
    enabled: !!input?.period,
  });
}

export function useLockMonth() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: lockMonth,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['trips'] });
      qc.invalidateQueries({ queryKey: ['deductions'] });
      qc.invalidateQueries({ queryKey: ['lock-month-preview'] });
    },
  });
}
